import * as React from 'react';
import {NotionWrapper} from '@ux/notion-api';

const NotionVoiceAndToneInterface = () => (
	<NotionWrapper blockMap={{
	"blocks": [
		{
			"id": "31c9a6bd-328b-4869-aecd-fabd86f3cf15",
			"type": "page",
			"properties": {
				"title": [
					[
						"Интерфейсные тексты"
					]
				]
			},
			"content": [
				"b3d23cfa-afaa-46a8-85cb-3d6c0c55fd33",
				"9f08d2e6-984d-4eb0-b1b0-3fb4d3b96b44",
				"a8a55e75-db09-4b58-af24-0af92814c21c",
				"afd79ba3-d2ae-4373-a8b1-49da234b2f8d",
				"0d8de00d-ff8e-4c3a-a5cf-ae06aa5a120a",
				"7d7fa69c-208a-420a-82e7-8ebc9103e50c",
				"7a5b6773-65f7-497b-8888-787d4f4a4703",
				"4bd99168-6e30-4b43-9c0b-4f5828ddd515",
				"6b642727-f8bc-4cab-b404-b945f74c42ca",
				"528cc7c9-b375-445f-adbd-284396c2848b",
				"c50dad2a-be5f-4e00-8869-c0a4211a646a",
				"67075283-1411-4926-b312-1c03bade4f7e",
				"d49b4893-66d6-428e-93ba-c0dcd1ca926b",
				"fdb213bd-8e32-4a75-8640-0d6063f7e48a",
				"3523508f-f108-41a2-afd2-a980e66ff247",
				"0e2862a3-db39-4e86-9ac4-81558fe6031e",
				"b7e68170-fce8-46fd-b043-d212ce468214",
				"3f16fd33-a18f-43fb-a18b-526a823336e9",
				"881569bb-b772-4a6e-898a-501e58f09470",
				"81c0d60b-fdd2-4b81-ba9d-f2fa60a68161",
				"46522384-6b80-4775-8deb-1b747377b47e",
				"e8d9ff6b-a03d-40af-a742-fef04fa19368",
				"4aa9da00-db0e-4bc3-a001-391b894c404a",
				"147c9b3e-ffbf-40b2-a885-a5da66fbbe59",
				"f911a9b8-f57c-427b-953a-12aecec7bd7c",
				"3dba190f-e1b5-471a-a709-43508be78e30",
				"b033793a-e999-497a-8ce9-0bd2b15e0837",
				"6425946e-d23a-42c0-aae7-7e1953872fff",
				"c1a6d07e-a6f9-4542-860b-fd647effd7b4",
				"d397907c-6653-4dcb-95d9-f49288bb4286",
				"69dbba0f-7216-4d58-9626-894d7577bc38",
				"2b0a0db0-ee61-4288-96cb-28b019179c27",
				"7f503518-8e92-4664-917e-ebf789a815b2",
				"5ba51341-265a-4c8f-910f-33002837cf1e",
				"0d30ccd0-c955-42f2-b070-e09fce91aff3",
				"f9563c6e-a48b-4266-b616-52cc81fb2c25",
				"0fab159d-62fe-417a-85a5-27be0d84e216",
				"77508c0d-e445-45d6-88bf-87270dd032c9",
				"bcd871d2-d13d-4ffe-a611-fe55dd35a248",
				"7109e5eb-b040-46e7-9bec-99bdda06bfdb",
				"83133309-2c76-4e2c-8bcf-327be7a76708",
				"ee4d6f55-edf8-4871-84a9-44b9a74eb8c0",
				"b90e6441-4524-4271-941f-d6b484091e82",
				"1dfa947b-8c0a-486b-9983-01d376068efa",
				"4aa6a65b-1de4-48c4-8491-7d46ee8f7cc7",
				"14881bee-82b9-461e-ab76-9805653984e8",
				"9d0de738-5045-4ac4-82b2-75a6c50f4d1d",
				"7a5e35b1-f541-4d20-b840-928e56932443",
				"403d1da7-c58d-4903-9b12-46c750aca63e",
				"d6331d4f-865d-4250-95d2-93828c234e11",
				"0ccf3666-e856-46b2-a49b-5645a1a03a4e",
				"9cb86318-b75b-42e6-aecc-dfc96750f5b1",
				"7f9ec2ee-a3fa-4c73-ac7f-0b34188a6251",
				"8488bb87-a262-44c5-a36d-9ae7b6ffc512",
				"1535c51a-c754-4f2d-a602-31d3c6d042f9",
				"509c1134-d986-4bd1-9d51-910e17b08d5e",
				"8ff8fc3f-8995-4873-bf2d-1b0e51495556",
				"42962707-4043-46ef-a250-4fb7bcf69dcb",
				"b3988dd0-2f22-4e26-b7d9-bf930a6ddc12",
				"1d78aa8d-a943-4727-888a-9ba777486fbb",
				"7fe927b4-2f10-4623-b2f3-43df158ff054",
				"5897b61c-37eb-4bae-8168-43fe4322fd71",
				"62d7c108-dc3a-4249-8962-4feecfcce0b6"
			],
			"parent_id": "a7f0ba9f-a91a-4924-8447-b93845e6da1c",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "a7f0ba9f-a91a-4924-8447-b93845e6da1c",
			"type": "page",
			"properties": {
				"title": [
					[
						"Paradigm"
					]
				]
			},
			"content": [
				"d4e0a1ac-e02e-4158-9d96-534ae9fa2c53",
				"b091b55a-a32c-4567-82d7-65c50636e3a7",
				"4e937b6d-4b2c-45c6-ab8c-e9dc9fa9bc2a",
				"7adbd680-541d-4e6e-97d1-f277bd1610c0",
				"ec15c567-4038-4c10-81bb-0a86aee56b08",
				"9a57d34b-41d2-40e4-8c4d-132953b7a175",
				"da552996-155b-442f-9ecf-0bdce521a35e",
				"1f51d543-236b-4b29-a278-4bed543f50b5",
				"5f304e57-18f8-4cd9-b80b-07951787740a",
				"f5097b73-1152-4e95-8919-54eed014af82",
				"94cd6ab9-c518-4094-829c-36d8a73e8010",
				"88cf99fd-dc9d-4649-8601-eb5198351e06",
				"d21336ae-ecfc-4130-a757-19109a89ad74",
				"e916c9a3-5983-4c34-bec3-187e417c593c",
				"cd7c41d2-ae59-4c69-b7d6-4254cf727ff5",
				"7ba8f4fe-6d71-4e1f-a1eb-1df9e3da0099",
				"31c9a6bd-328b-4869-aecd-fabd86f3cf15",
				"cb2b1b2c-b795-4abf-b11f-772b33e43908",
				"a47c1d35-578a-4679-8907-d8b13ab1bb65",
				"41e2749d-ddd3-4a06-b224-0ae6b4c9d436",
				"c3e7c6b7-650d-456d-8997-a4d049587d58",
				"7472c506-f9da-4f2e-85ba-59623551e747",
				"16b738c5-499f-42a0-baf4-cffb990a0b25",
				"51181f46-f9ad-4d25-b2c3-a59f7c7b8587",
				"e8ea6408-fc0d-4be8-8020-e982cc7c9b55",
				"3143e3ff-a6eb-4e48-8197-d96fceb48f9e",
				"20802187-e25a-4d38-af64-a363ffcace1d",
				"311c23ba-4ac6-48a0-bf3b-de8b115c363f",
				"aec03706-7113-42af-8724-4b446502d53a",
				"4836526c-ce6a-4bfd-8c2f-4bcb9a446e1e",
				"e0b8f319-a947-4c5d-8bdf-cd0ffeea5a6d",
				"aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
				"98a66dbd-731e-498f-9c5f-7790d1f555e0",
				"c7ec9e06-de22-4861-88e6-e6d45e0de285",
				"55690b50-0664-4442-9ded-4645f2f318e9"
			],
			"parent_id": "1fcd74a2-648f-4dfc-a4d8-abbb9a7bfb29",
			"parent_table": "team",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "b3d23cfa-afaa-46a8-85cb-3d6c0c55fd33",
			"type": "code",
			"properties": {
				"title": [
					[
						"<meta type=\"url\" value=\"/voice_and_tone/interface\"/>"
					]
				],
				"language": [
					[
						"JavaScript"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "eee82228-305a-43ad-b48e-7daf90a49a04",
					"table": "block",
					"spaceId": "22066aad-9295-4afc-88d1-dae5d26fea31"
				}
			},
			"parent_id": "31c9a6bd-328b-4869-aecd-fabd86f3cf15",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "9f08d2e6-984d-4eb0-b1b0-3fb4d3b96b44",
			"type": "text",
			"properties": {
				"title": [
					[
						"Интерфейсный текст — короткое сообщение, которое должно помочь пользователю, объяснить суть, подсказать и направить по нужному пути."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "000e0948-e921-4cab-ade3-8b06480ee3f5",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "31c9a6bd-328b-4869-aecd-fabd86f3cf15",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "a8a55e75-db09-4b58-af24-0af92814c21c",
			"type": "text",
			"properties": {
				"title": [
					[
						"Любой интерфейсный элемент строится по принципу:"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "8009a51b-2949-4b34-bfe9-18a61b5b8951",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "31c9a6bd-328b-4869-aecd-fabd86f3cf15",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "afd79ba3-d2ae-4373-a8b1-49da234b2f8d",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"главное — вперёд"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "110507e2-9d49-4b5c-8865-658b03e812ef",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "31c9a6bd-328b-4869-aecd-fabd86f3cf15",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "0d8de00d-ff8e-4c3a-a5cf-ae06aa5a120a",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"с пользой для человека"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "24223b96-264f-4b18-ad94-f189086f93a8",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "31c9a6bd-328b-4869-aecd-fabd86f3cf15",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "7d7fa69c-208a-420a-82e7-8ebc9103e50c",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"лаконично, точно, консистентно"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "148f35df-2bc3-415a-9ec2-1862231190ad",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "31c9a6bd-328b-4869-aecd-fabd86f3cf15",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "7a5b6773-65f7-497b-8888-787d4f4a4703",
			"type": "header",
			"properties": {
				"title": [
					[
						"Главное для человека — вперёд"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "092887e7-e3fa-4e41-b496-adffbcb7c3c4",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "31c9a6bd-328b-4869-aecd-fabd86f3cf15",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "4bd99168-6e30-4b43-9c0b-4f5828ddd515",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Главное — вперёд "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "5dd4accf-da3c-4192-ba86-c6359632af82",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "31c9a6bd-328b-4869-aecd-fabd86f3cf15",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "6b642727-f8bc-4cab-b404-b945f74c42ca",
			"type": "text",
			"properties": {
				"title": [
					[
						"Заголовок, если он есть, должен отражать суть и помогать человеку оказаться в той точке сценария, где ему нужно быть в конкретный момент. "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "b6fbc5a0-e682-4cca-8a25-810ec60424c8",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "31c9a6bd-328b-4869-aecd-fabd86f3cf15",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "528cc7c9-b375-445f-adbd-284396c2848b",
			"type": "text",
			"properties": {
				"title": [
					[
						"Подзаголовок, если он есть — должен быть самодостаточным, при этом давать дополнительные детали к заголовку, если это нужно. "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "049bbeeb-4d51-4278-bfe6-79942380ca12",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "31c9a6bd-328b-4869-aecd-fabd86f3cf15",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "c50dad2a-be5f-4e00-8869-c0a4211a646a",
			"type": "text",
			"properties": {
				"title": [
					[
						"Заголовок — для человека и про него, а не про компанию или технические особенности."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "5118a9eb-5565-474d-9d43-6b5bfb7a8cc0",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "31c9a6bd-328b-4869-aecd-fabd86f3cf15",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "67075283-1411-4926-b312-1c03bade4f7e",
			"type": "column_list",
			"content": [
				"90df1be5-4be3-4ce1-abdb-cec6b13d183b",
				"65d6cec6-5387-44c8-98c6-6c015e4b7ead"
			],
			"format": {
				"copied_from_pointer": {
					"id": "764bc605-55fd-4f9d-a388-221d8d40200a",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "31c9a6bd-328b-4869-aecd-fabd86f3cf15",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "d49b4893-66d6-428e-93ba-c0dcd1ca926b",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Человек — в центре "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "c74b2bbb-e992-477d-b598-ddd41b2ea404",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "31c9a6bd-328b-4869-aecd-fabd86f3cf15",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "fdb213bd-8e32-4a75-8640-0d6063f7e48a",
			"type": "text",
			"properties": {
				"title": [
					[
						"«Мы проверяем», «мы сохранили» — подобные уточнения часто лежат «под капотом», человеку знать о них не нужно. На первом месте всегда человек и задача, которую он хочет решить.  "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "2e20fe9f-50da-4fd9-8f7b-393fafd086ca",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "31c9a6bd-328b-4869-aecd-fabd86f3cf15",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "3523508f-f108-41a2-afd2-a980e66ff247",
			"type": "text",
			"properties": {
				"title": [
					[
						"Как себя проверить:"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "14405f47-bc47-4427-bc25-7a97c937ca4d",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "31c9a6bd-328b-4869-aecd-fabd86f3cf15",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "0e2862a3-db39-4e86-9ac4-81558fe6031e",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"если заметили фразу в формате «мы, нам, у нас» и т. д. — подумайте, как её увидит человек. Увидит ли в ней себя и заботу о себе? Если да — окей, \nнет — перефразируйте так, чтобы она была про человека или про предмет действия (интерес, заявка, письмо)"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "bacc132b-d14f-4669-a7d4-e9bedee37c5a",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "31c9a6bd-328b-4869-aecd-fabd86f3cf15",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "b7e68170-fce8-46fd-b043-d212ce468214",
			"type": "column_list",
			"content": [
				"9d94e636-afa3-4a2e-a150-09196d989631",
				"c4c9f6fa-fd15-4730-958e-f5cabb5fdf21"
			],
			"format": {
				"copied_from_pointer": {
					"id": "131af8df-3409-4503-b96b-cccb37ad70de",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "31c9a6bd-328b-4869-aecd-fabd86f3cf15",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "3f16fd33-a18f-43fb-a18b-526a823336e9",
			"type": "column_list",
			"content": [
				"66c48ff5-12b1-4329-95da-f007a7e52e03",
				"88ac19b4-ba82-4987-95fa-7f65291c6da9"
			],
			"format": {
				"copied_from_pointer": {
					"id": "8a9af786-874e-4d67-8f1c-c196047e6db3",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "31c9a6bd-328b-4869-aecd-fabd86f3cf15",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "881569bb-b772-4a6e-898a-501e58f09470",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"На языке и в мире человека"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "bf030a5a-39fd-400b-bef2-27ceb8af335a",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "31c9a6bd-328b-4869-aecd-fabd86f3cf15",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "81c0d60b-fdd2-4b81-ba9d-f2fa60a68161",
			"type": "text",
			"properties": {
				"title": [
					[
						"Технические особенности, то есть то, что происходит «под капотом», человеку знать не нужно. Это не помогает, но запутывает и фрустрирует. Говорим на языке человека, о том, что важно для него. "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "f47d7edd-757c-49a9-841e-b3cd44b6cef0",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "31c9a6bd-328b-4869-aecd-fabd86f3cf15",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "46522384-6b80-4775-8deb-1b747377b47e",
			"type": "column_list",
			"content": [
				"cbd5a22f-53aa-4dae-a5b0-9d725fb41d39",
				"e07dd7c1-a8e4-48fb-9e40-1a5b235d078b"
			],
			"format": {
				"copied_from_pointer": {
					"id": "0802aa6b-d0e5-490c-9ec3-8509c1c26f95",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "31c9a6bd-328b-4869-aecd-fabd86f3cf15",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "e8d9ff6b-a03d-40af-a742-fef04fa19368",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Предмет действия определён и понятен "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "05f84f44-bdcd-4b01-8ac6-dbb771c65311",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "31c9a6bd-328b-4869-aecd-fabd86f3cf15",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "4aa9da00-db0e-4bc3-a001-391b894c404a",
			"type": "text",
			"properties": {
				"title": [
					[
						"Человек должен понять, о чём речь здесь и сейчас. Ему не нужно держать в голове названия продуктов, статусов, предыдущих действий. "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "d8126094-3c6f-4cef-b4f5-ce5e6c1fde79",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "31c9a6bd-328b-4869-aecd-fabd86f3cf15",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "147c9b3e-ffbf-40b2-a885-a5da66fbbe59",
			"type": "text",
			"properties": {
				"title": [
					[
						"Как себя проверить:"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "1c4d19dd-f5e8-4db3-a388-fc12e0468b40",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "31c9a6bd-328b-4869-aecd-fabd86f3cf15",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "f911a9b8-f57c-427b-953a-12aecec7bd7c",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"абстрагируйтесь от контекста и прочитайте текст на элементе, словно вы видите его впервые. Если понятно, о чём речь — вы на верном пути. "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "38ec60c2-2a6c-418d-aafb-7f1eb703d505",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "31c9a6bd-328b-4869-aecd-fabd86f3cf15",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "3dba190f-e1b5-471a-a709-43508be78e30",
			"type": "column_list",
			"content": [
				"08519255-b76e-4ce9-b448-c21f5d94d4a6",
				"6371b570-cba2-4780-93fa-6f18bccd53dd"
			],
			"format": {
				"copied_from_pointer": {
					"id": "de4af847-5c55-429d-8653-71a5b228a346",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "31c9a6bd-328b-4869-aecd-fabd86f3cf15",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "b033793a-e999-497a-8ce9-0bd2b15e0837",
			"type": "header",
			"properties": {
				"title": [
					[
						"Польза и помощь"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "2a25d6eb-fb79-44bf-aa0c-a23d2d24d2b2",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "31c9a6bd-328b-4869-aecd-fabd86f3cf15",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "6425946e-d23a-42c0-aae7-7e1953872fff",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Помогаем здесь и сейчас (если можем)"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "c4fe91ce-a6c5-43c6-b984-439295d12f4a",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "31c9a6bd-328b-4869-aecd-fabd86f3cf15",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "c1a6d07e-a6f9-4542-860b-fd647effd7b4",
			"type": "text",
			"properties": {
				"title": [
					[
						"При возникновении корнер-кейса, ошибки, задержки на стороне сервиса — никогда не бросаем фрустрированного человека. Не пугаем, не погружаем в технические тонкости. Рассказываем, что человек может сделать, чтобы решить проблему, или просим вернуться в сервис чуть позже. "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "7c79e58b-1cbf-4398-9fb0-01ac92871401",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "31c9a6bd-328b-4869-aecd-fabd86f3cf15",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "d397907c-6653-4dcb-95d9-f49288bb4286",
			"type": "column_list",
			"content": [
				"791cb351-1242-41aa-bf68-fd2a2954eb1a",
				"93c5bd63-b4ae-41ee-8bd2-1aced659f8c9"
			],
			"format": {
				"copied_from_pointer": {
					"id": "73ada582-fb6d-49fe-847e-64ab8cb1e274",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "31c9a6bd-328b-4869-aecd-fabd86f3cf15",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "69dbba0f-7216-4d58-9626-894d7577bc38",
			"type": "column_list",
			"content": [
				"41024785-c813-4fe6-9ca3-6bbe3e99ea84",
				"fdf5ee8e-1648-4353-b45d-7764cd558c63"
			],
			"format": {
				"copied_from_pointer": {
					"id": "fd7edb70-55e4-4ef9-baa8-a81a7ae565bd",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "31c9a6bd-328b-4869-aecd-fabd86f3cf15",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "2b0a0db0-ee61-4288-96cb-28b019179c27",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Интерфейс — не актор"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "0f1f0e94-5165-40bc-a729-2e1384958423",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "31c9a6bd-328b-4869-aecd-fabd86f3cf15",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "7f503518-8e92-4664-917e-ebf789a815b2",
			"type": "text",
			"properties": {
				"title": [
					[
						"Интерфейсные сообщения — чаще обезличенные. Это не значит, что они \nне заботливые, но лицо здесь не важно. Важно, чтобы человек быстро считал и понял, что ему нужно сделать. "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "7bca9a15-0cd1-46d3-9591-bf9c43866786",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "31c9a6bd-328b-4869-aecd-fabd86f3cf15",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "5ba51341-265a-4c8f-910f-33002837cf1e",
			"type": "text",
			"properties": {
				"title": [
					[
						"Исключения: сообщения от поддержки. "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "62b99784-132a-4989-a7ac-4127edcddcfb",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "31c9a6bd-328b-4869-aecd-fabd86f3cf15",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "0d30ccd0-c955-42f2-b070-e09fce91aff3",
			"type": "column_list",
			"content": [
				"ba10075f-1e7e-427d-99b7-0fca0feab4da",
				"68cae18c-3a9d-4db6-99eb-4a690b91643b"
			],
			"format": {
				"copied_from_pointer": {
					"id": "a8959057-d55f-417a-a0ee-ddec5bf88d60",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "31c9a6bd-328b-4869-aecd-fabd86f3cf15",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "f9563c6e-a48b-4266-b616-52cc81fb2c25",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Снижаем когнитивную нагрузку"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "af5d1e3c-dc98-447e-ba77-a7000dcb122a",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "31c9a6bd-328b-4869-aecd-fabd86f3cf15",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "0fab159d-62fe-417a-85a5-27be0d84e216",
			"type": "text",
			"properties": {
				"title": [
					[
						"Одно слово — одно понятие.  "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "a5668058-5b83-44e9-89b1-9a718dc5be24",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "31c9a6bd-328b-4869-aecd-fabd86f3cf15",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "77508c0d-e445-45d6-88bf-87270dd032c9",
			"type": "column_list",
			"content": [
				"a611fb48-0219-4f35-91e4-e51ac884faa0",
				"b5597867-a03e-413b-9038-ce903d910f8b"
			],
			"format": {
				"copied_from_pointer": {
					"id": "be65fd61-aefe-49ac-9a6e-f9262f8a536f",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "31c9a6bd-328b-4869-aecd-fabd86f3cf15",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "bcd871d2-d13d-4ffe-a611-fe55dd35a248",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Наводим визуальный порядок"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "ee3d75d9-f36d-4841-84d5-598f238e1383",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "31c9a6bd-328b-4869-aecd-fabd86f3cf15",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "7109e5eb-b040-46e7-9bec-99bdda06bfdb",
			"type": "text",
			"properties": {
				"title": [
					[
						"Визуальная стройность управляет вниманием человека. Переносы, буллиты и подобные элементы станут акцентом и подскажут человеку, куда смотреть в первую очередь. "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "6708c39f-9abd-487d-8bda-91a9cd0a5301",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "31c9a6bd-328b-4869-aecd-fabd86f3cf15",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "83133309-2c76-4e2c-8bcf-327be7a76708",
			"type": "column_list",
			"content": [
				"3f411231-1c05-4044-b6c8-e8f07fe31dba",
				"16125059-7f7b-4ffd-8b6d-05c04f7861a6"
			],
			"format": {
				"copied_from_pointer": {
					"id": "57daa7e4-e7e6-444f-a7b0-2618faf57316",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "31c9a6bd-328b-4869-aecd-fabd86f3cf15",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "ee4d6f55-edf8-4871-84a9-44b9a74eb8c0",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Подсказываем"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "c19ff530-7d04-42b5-9846-f84094a052ed",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "31c9a6bd-328b-4869-aecd-fabd86f3cf15",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "b90e6441-4524-4271-941f-d6b484091e82",
			"type": "text",
			"properties": {
				"title": [
					[
						"Подсказываем человеку там, где нам важно снизить его когнитивную нагрузку, и делаем всё, чтобы он преодолел сценарий без ошибок.  "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "560d921d-b24a-42cb-b200-a9bcf1b7751b",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "31c9a6bd-328b-4869-aecd-fabd86f3cf15",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "1dfa947b-8c0a-486b-9983-01d376068efa",
			"type": "column_list",
			"content": [
				"8c07149c-d46c-4fdf-85ad-ea9ba47ca960",
				"7f255c25-629b-482b-ae7c-9656d63a0ead"
			],
			"format": {
				"copied_from_pointer": {
					"id": "578a2a1c-50dd-4556-9258-c4ed97a1c4d2",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "31c9a6bd-328b-4869-aecd-fabd86f3cf15",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "4aa6a65b-1de4-48c4-8491-7d46ee8f7cc7",
			"type": "header",
			"properties": {
				"title": [
					[
						"Лаконично, точно, консистентно "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "16462dc1-baef-4c2c-8181-7dc344de2a1d",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "31c9a6bd-328b-4869-aecd-fabd86f3cf15",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "14881bee-82b9-461e-ab76-9805653984e8",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Убираем лишнее"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "098d6f51-acfc-45c4-9a62-c181da8ea30c",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "31c9a6bd-328b-4869-aecd-fabd86f3cf15",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "9d0de738-5045-4ac4-82b2-75a6c50f4d1d",
			"type": "text",
			"properties": {
				"title": [
					[
						"Укажите только то, что нужно человеку в данный момент. Не перегружайте информацией и несколькими CTА. Одно действие = одно сообщение. \n "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "125f5c8a-3770-4fa4-9e18-b4e67ae77209",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "31c9a6bd-328b-4869-aecd-fabd86f3cf15",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "7a5e35b1-f541-4d20-b840-928e56932443",
			"type": "column_list",
			"content": [
				"29408658-f118-4d45-b985-df506284e5c2",
				"6660c04b-9b0f-4da7-ae62-7255ca52ee1f"
			],
			"format": {
				"copied_from_pointer": {
					"id": "197af433-fc4d-4427-b53e-cc663c4f533a",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "31c9a6bd-328b-4869-aecd-fabd86f3cf15",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "403d1da7-c58d-4903-9b12-46c750aca63e",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Конкретно"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "8803920e-3097-44b0-a97a-6820aa560703",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "31c9a6bd-328b-4869-aecd-fabd86f3cf15",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "d6331d4f-865d-4250-95d2-93828c234e11",
			"type": "text",
			"properties": {
				"title": [
					[
						"Ведём человека по сценарию за руку — не даём повод додумывать и ошибаться.  "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "ad862eed-d308-44c7-a2a9-f6951b38600a",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "31c9a6bd-328b-4869-aecd-fabd86f3cf15",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "0ccf3666-e856-46b2-a49b-5645a1a03a4e",
			"type": "column_list",
			"content": [
				"986672ce-7d08-4d04-ad08-ba5f1755fbfb",
				"8a40e9cd-38b2-45a6-ae81-7bc12f4a4e0d"
			],
			"format": {
				"copied_from_pointer": {
					"id": "1f0e0d60-d591-4d51-8097-afc4d0af9a7d",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "31c9a6bd-328b-4869-aecd-fabd86f3cf15",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "9cb86318-b75b-42e6-aecc-dfc96750f5b1",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Однозначно"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "f858acbc-5f53-46db-bf01-caf2951edd33",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "31c9a6bd-328b-4869-aecd-fabd86f3cf15",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "7f9ec2ee-a3fa-4c73-ac7f-0b34188a6251",
			"type": "text",
			"properties": {
				"title": [
					[
						"Интерфейсный элемент должен сообщать пользователю однозначное послание — двусмысленность недопустима. "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "98a9201a-6e72-440c-a632-461b8abf44b1",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "31c9a6bd-328b-4869-aecd-fabd86f3cf15",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "8488bb87-a262-44c5-a36d-9ae7b6ffc512",
			"type": "column_list",
			"content": [
				"7515f335-4867-4de2-ad50-35f68711fa07",
				"7bf106db-cd26-4155-9fd3-ee3426b8a2fb"
			],
			"format": {
				"copied_from_pointer": {
					"id": "2f77d0c2-67f7-4a1b-adc8-fc4c812f261c",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "31c9a6bd-328b-4869-aecd-fabd86f3cf15",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "1535c51a-c754-4f2d-a602-31d3c6d042f9",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Согласованно"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "a87ae396-f005-4c2a-8398-611ed0e837b0",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "31c9a6bd-328b-4869-aecd-fabd86f3cf15",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "509c1134-d986-4bd1-9d51-910e17b08d5e",
			"type": "text",
			"properties": {
				"title": [
					[
						"Заголовок + кнопка — должны составлять единое целое. Прочитав заголовок и то, что написано на кнопке, человек должен понять, что его ждёт дальше. "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "affa4318-f992-4924-b6a5-faecbd11072b",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "31c9a6bd-328b-4869-aecd-fabd86f3cf15",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "8ff8fc3f-8995-4873-bf2d-1b0e51495556",
			"type": "text",
			"properties": {
				"title": [
					[
						"Как себя проверить:"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "42bcd5c2-68c4-48cc-ba0d-ea176531c403",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "31c9a6bd-328b-4869-aecd-fabd86f3cf15",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "42962707-4043-46ef-a250-4fb7bcf69dcb",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Прочитайте заголовок и текст на кнопке — если фраза звучит естественно \nи цельно, скорее всего, вы на верном пути"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "503807d9-467f-401e-b219-6bf2001de470",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "31c9a6bd-328b-4869-aecd-fabd86f3cf15",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "b3988dd0-2f22-4e26-b7d9-bf930a6ddc12",
			"type": "column_list",
			"content": [
				"7d5fbfd5-72de-4655-828b-47939335c012",
				"a04d2ec9-bd8d-480c-8375-6b6f4196e7d3"
			],
			"format": {
				"copied_from_pointer": {
					"id": "0873d751-85e6-4354-b61a-aa6e199f5bfd",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "31c9a6bd-328b-4869-aecd-fabd86f3cf15",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "1d78aa8d-a943-4727-888a-9ba777486fbb",
			"type": "column_list",
			"content": [
				"b52d904f-85f0-4110-86dc-b6fcc4e236a8",
				"484161ae-20f0-481a-b069-0f83de7738b5"
			],
			"format": {
				"copied_from_pointer": {
					"id": "e1f0f959-8800-40f1-91c9-51c9f45f9f5c",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "31c9a6bd-328b-4869-aecd-fabd86f3cf15",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "7fe927b4-2f10-4623-b2f3-43df158ff054",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Консистентно "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "357d1dde-826a-4e66-9e93-ea44f78741ce",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "31c9a6bd-328b-4869-aecd-fabd86f3cf15",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "5897b61c-37eb-4bae-8168-43fe4322fd71",
			"type": "text",
			"properties": {
				"title": [
					[
						"Элементы в интерфейсе должны быть согласованы между собой — так их легче считывать. Элементами могут быть слова, фразы, предложения, абзацы.    "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "69c03d53-e264-44e3-b792-f3aa01b0aa72",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "31c9a6bd-328b-4869-aecd-fabd86f3cf15",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "62d7c108-dc3a-4249-8962-4feecfcce0b6",
			"type": "column_list",
			"content": [
				"b906eafc-7595-4f40-a47b-cef03dc1bbf0",
				"42e7fd64-f04b-4be9-928a-1152e38230fa"
			],
			"format": {
				"copied_from_pointer": {
					"id": "4519d5f2-a4d5-47fd-9070-992e29da5d0b",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "31c9a6bd-328b-4869-aecd-fabd86f3cf15",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "90df1be5-4be3-4ce1-abdb-cec6b13d183b",
			"type": "column",
			"content": [
				"196eb2b5-b4fc-4478-8994-4cc4da76ad79",
				"ba6aec2d-1068-430e-a644-3ef631128c4d"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "de89a507-4629-4f34-a035-62e20159ef03",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "67075283-1411-4926-b312-1c03bade4f7e",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "65d6cec6-5387-44c8-98c6-6c015e4b7ead",
			"type": "column",
			"content": [
				"ff902bf3-7e29-42e9-a116-61e7866d75c6",
				"7ef26db9-db83-4e16-ba8d-d6a924a19add"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "34b34235-dab1-4447-a707-271315e897e5",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "67075283-1411-4926-b312-1c03bade4f7e",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "196eb2b5-b4fc-4478-8994-4cc4da76ad79",
			"type": "image",
			"properties": {
				"size": [
					[
						"254.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/1b227875-a8cc-43e2-b75e-a6754bc45c96/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/1b227875-a8cc-43e2-b75e-a6754bc45c96/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.9563953488372093,
				"block_preserve_scale": true
			},
			"parent_id": "90df1be5-4be3-4ce1-abdb-cec6b13d183b",
			"parent_table": "block",
			"file_ids": [
				"1b227875-a8cc-43e2-b75e-a6754bc45c96"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/196eb2b5-b4fc-4478-8994-4cc4da76ad79.png"
		},
		{
			"id": "ba6aec2d-1068-430e-a644-3ef631128c4d",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Главное — впереди. А главное здесь то, что человек не может отправить фотки, а не что-то про хранилище. \n\nВ подзаголовке даём пояснения. \n \nПодзаголовок — самодостаточный, читается сам по себе без привязки к заголовку.  \n\nЗаголовок+кнопка — читаются связно и логично. "
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "7936d597-c255-4302-b685-1be6ff9ab1cd",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "90df1be5-4be3-4ce1-abdb-cec6b13d183b",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "ff902bf3-7e29-42e9-a116-61e7866d75c6",
			"type": "image",
			"properties": {
				"size": [
					[
						"253.8KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/b72d4514-987c-441f-a11b-25d2b1db6873/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/b72d4514-987c-441f-a11b-25d2b1db6873/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.9563953488372093,
				"block_preserve_scale": true
			},
			"parent_id": "65d6cec6-5387-44c8-98c6-6c015e4b7ead",
			"parent_table": "block",
			"file_ids": [
				"b72d4514-987c-441f-a11b-25d2b1db6873"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/ff902bf3-7e29-42e9-a116-61e7866d75c6.png"
		},
		{
			"id": "7ef26db9-db83-4e16-ba8d-d6a924a19add",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Мне про какое-то хранилище \nв момент, когда я не могу отправить фотки другу. \n\nПодзаголовок — не про заботу, а про продажу. \n\nКнопки — путают, потому что они про одно и то же: «увеличить» и «освободить» приведут к одному и тому же "
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "bb9a7910-c1fd-4c40-bd4f-eca3554fae09",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "65d6cec6-5387-44c8-98c6-6c015e4b7ead",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "9d94e636-afa3-4a2e-a150-09196d989631",
			"type": "column",
			"content": [
				"db70ab69-cb6e-4b7e-802a-2d541e852405",
				"53f21490-a083-45f5-9c3a-bab816f3f308"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "dd3024b4-438c-4657-9209-2e39637b4081",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "b7e68170-fce8-46fd-b043-d212ce468214",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "c4c9f6fa-fd15-4730-958e-f5cabb5fdf21",
			"type": "column",
			"content": [
				"9e5a84be-58f5-4b32-ab56-a3f6e7fafa87",
				"cc009519-057d-4031-b080-0a3a8bea186c"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "9c53e2a2-45a5-414e-b74a-23ef5b26f5a5",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "b7e68170-fce8-46fd-b043-d212ce468214",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "db70ab69-cb6e-4b7e-802a-2d541e852405",
			"type": "image",
			"properties": {
				"size": [
					[
						"122.5KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/5f8c2482-9e03-4ba8-88a8-bbf318782187/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/5f8c2482-9e03-4ba8-88a8-bbf318782187/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.5523255813953488,
				"block_preserve_scale": true
			},
			"parent_id": "9d94e636-afa3-4a2e-a150-09196d989631",
			"parent_table": "block",
			"file_ids": [
				"5f8c2482-9e03-4ba8-88a8-bbf318782187"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/db70ab69-cb6e-4b7e-802a-2d541e852405.png"
		},
		{
			"id": "53f21490-a083-45f5-9c3a-bab816f3f308",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Уже в заголовке интересуемся мнением человека\n\nГоворим о том, что можно,\nа не о том, что нельзя. "
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "f1df4c3b-9745-4ebe-9b0f-ca69bfd13449",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "9d94e636-afa3-4a2e-a150-09196d989631",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "9e5a84be-58f5-4b32-ab56-a3f6e7fafa87",
			"type": "image",
			"properties": {
				"size": [
					[
						"123.5KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/61e27615-5002-43d2-abe0-246b19acc2f1/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 1032,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/61e27615-5002-43d2-abe0-246b19acc2f1/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.5523255813953488,
				"block_preserve_scale": true
			},
			"parent_id": "c4c9f6fa-fd15-4730-958e-f5cabb5fdf21",
			"parent_table": "block",
			"file_ids": [
				"61e27615-5002-43d2-abe0-246b19acc2f1"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/9e5a84be-58f5-4b32-ab56-a3f6e7fafa87.png"
		},
		{
			"id": "cc009519-057d-4031-b080-0a3a8bea186c",
			"type": "callout",
			"properties": {
				"title": [
					[
						"В заголовке и подзаголовке два отрицания — интерфейс уже что-то не может.  \n\nЗдесь нет человека — только интерес компании. "
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "af8a91ec-8cb9-4796-848d-7f60cc2463b1",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "c4c9f6fa-fd15-4730-958e-f5cabb5fdf21",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "66c48ff5-12b1-4329-95da-f007a7e52e03",
			"type": "column",
			"content": [
				"ed80e49b-dc6a-4239-b986-aeb0d377979f",
				"0470a0a7-7e60-4892-a516-8f3abbd1ff01",
				"219e559b-875a-4e5f-8220-e37ee10ae31f"
			],
			"format": {
				"column_ratio": 0.49999999999999994,
				"copied_from_pointer": {
					"id": "b77cecd1-bb8b-4b63-86d2-cdd3562b7633",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "3f16fd33-a18f-43fb-a18b-526a823336e9",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "88ac19b4-ba82-4987-95fa-7f65291c6da9",
			"type": "column",
			"content": [
				"c56848ef-6334-4382-a359-31d30869c5bf",
				"3869948d-0413-43e4-8687-17839b7e30e6"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "49857ae4-8ba8-4d2a-add3-249499d1bc7b",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "3f16fd33-a18f-43fb-a18b-526a823336e9",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "ed80e49b-dc6a-4239-b986-aeb0d377979f",
			"type": "image",
			"properties": {
				"size": [
					[
						"66.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/8e2637df-5f6a-43fc-a2d4-43027fc50ef2/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/8e2637df-5f6a-43fc-a2d4-43027fc50ef2/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.5319767441860465,
				"block_preserve_scale": true
			},
			"parent_id": "66c48ff5-12b1-4329-95da-f007a7e52e03",
			"parent_table": "block",
			"file_ids": [
				"8e2637df-5f6a-43fc-a2d4-43027fc50ef2"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/ed80e49b-dc6a-4239-b986-aeb0d377979f.png"
		},
		{
			"id": "0470a0a7-7e60-4892-a516-8f3abbd1ff01",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Сказали о самом важном для человека в чувствительный \nмомент — с файлами всё окей. \n \nОбъяснили, что ждать. "
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "5cb2ba20-d035-4812-bdbe-297081c9536c",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "66c48ff5-12b1-4329-95da-f007a7e52e03",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "219e559b-875a-4e5f-8220-e37ee10ae31f",
			"type": "text",
			"format": {
				"copied_from_pointer": {
					"id": "fba4e31a-1cbf-48dd-b7b9-b539b6d70978",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "66c48ff5-12b1-4329-95da-f007a7e52e03",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "c56848ef-6334-4382-a359-31d30869c5bf",
			"type": "image",
			"properties": {
				"size": [
					[
						"79.2KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/8e184afc-a2eb-449e-993b-0af59b04a68f/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/8e184afc-a2eb-449e-993b-0af59b04a68f/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.5319767441860465,
				"block_preserve_scale": true
			},
			"parent_id": "88ac19b4-ba82-4987-95fa-7f65291c6da9",
			"parent_table": "block",
			"file_ids": [
				"8e184afc-a2eb-449e-993b-0af59b04a68f"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/c56848ef-6334-4382-a359-31d30869c5bf.png"
		},
		{
			"id": "3869948d-0413-43e4-8687-17839b7e30e6",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Канцеляризм — «требует исправить»\n\nЗдесь нет боли человека — «мы сохранили», но что это для меня. \n\nИзбыточность — можно короче без потери смысла.  "
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "7629160d-0732-4ae1-ae64-aec2ac88ab1f",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "88ac19b4-ba82-4987-95fa-7f65291c6da9",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "cbd5a22f-53aa-4dae-a5b0-9d725fb41d39",
			"type": "column",
			"content": [
				"1f3f882f-8c0f-448d-adac-49c7ff5cf5e7",
				"e1554eb9-aaf3-45b3-9c14-75fcaef6c787"
			],
			"format": {
				"column_ratio": 0.49999999999999994,
				"copied_from_pointer": {
					"id": "3b145648-a87b-4d59-8f05-15eab75bf857",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "46522384-6b80-4775-8deb-1b747377b47e",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "e07dd7c1-a8e4-48fb-9e40-1a5b235d078b",
			"type": "column",
			"content": [
				"f43ede45-8e83-40aa-b278-80ca0122dd3e",
				"f02ab9fd-8856-4cda-b5cc-24c93ab9997a",
				"73d9653e-bdfc-43fe-b2bf-4fe654bf3d28"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "379953fe-c5cf-4f7c-877b-340b12313905",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "46522384-6b80-4775-8deb-1b747377b47e",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "1f3f882f-8c0f-448d-adac-49c7ff5cf5e7",
			"type": "image",
			"properties": {
				"size": [
					[
						"121.8KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/9bae01fa-7747-4669-a6f9-fb662918ce6e/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/9bae01fa-7747-4669-a6f9-fb662918ce6e/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 1.2703488372093024,
				"block_preserve_scale": true
			},
			"parent_id": "cbd5a22f-53aa-4dae-a5b0-9d725fb41d39",
			"parent_table": "block",
			"file_ids": [
				"9bae01fa-7747-4669-a6f9-fb662918ce6e"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/1f3f882f-8c0f-448d-adac-49c7ff5cf5e7.png"
		},
		{
			"id": "e1554eb9-aaf3-45b3-9c14-75fcaef6c787",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Очеловечили — «Придумайте название»\n\nПривели к единообразию пункты — читать легко: вложить, читать, защитить \n\nПодправили кнопки — теперь они звучат логично с заголовком "
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "c2c87051-cdd8-48b2-822a-d07aa0eefd8a",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "cbd5a22f-53aa-4dae-a5b0-9d725fb41d39",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "f43ede45-8e83-40aa-b278-80ca0122dd3e",
			"type": "image",
			"properties": {
				"size": [
					[
						"119.1KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/9fb87cb1-f73a-446c-8b67-66c619f0e449/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/9fb87cb1-f73a-446c-8b67-66c619f0e449/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 1.2703488372093024,
				"block_preserve_scale": true
			},
			"parent_id": "e07dd7c1-a8e4-48fb-9e40-1a5b235d078b",
			"parent_table": "block",
			"file_ids": [
				"9fb87cb1-f73a-446c-8b67-66c619f0e449"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/f43ede45-8e83-40aa-b278-80ca0122dd3e.png"
		},
		{
			"id": "f02ab9fd-8856-4cda-b5cc-24c93ab9997a",
			"type": "callout",
			"properties": {
				"title": [
					[
						"POP3 — 99% людей не должны разбираться в таких технических тонкостях\n\nНеконсистентные элементы\n \nОтглагольные \n\nНе хватает простых подсказок "
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "a83fb7b0-76cd-474e-a678-ce161f67f377",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "e07dd7c1-a8e4-48fb-9e40-1a5b235d078b",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "73d9653e-bdfc-43fe-b2bf-4fe654bf3d28",
			"type": "text",
			"parent_id": "e07dd7c1-a8e4-48fb-9e40-1a5b235d078b",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "08519255-b76e-4ce9-b448-c21f5d94d4a6",
			"type": "column",
			"content": [
				"8c967454-2b72-4c95-ad7f-3691c1b90294",
				"1a720ced-0bbb-4165-9a52-ba8b5ce30f41"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "5c7d7d8e-e0f4-4a22-aa04-7d949ce8be62",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "3dba190f-e1b5-471a-a709-43508be78e30",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "6371b570-cba2-4780-93fa-6f18bccd53dd",
			"type": "column",
			"content": [
				"921c2b52-86cb-45f7-a23f-ee345d33203a",
				"ae84e551-db85-4a90-a8e8-3d2f55ac5fb2"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "834abb47-fd3d-46c9-83f4-321e01a07d6b",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "3dba190f-e1b5-471a-a709-43508be78e30",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "8c967454-2b72-4c95-ad7f-3691c1b90294",
			"type": "image",
			"properties": {
				"size": [
					[
						"112.7KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/872bdca1-017c-4611-ab60-376b24452c0d/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/872bdca1-017c-4611-ab60-376b24452c0d/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.27906976744186046,
				"block_preserve_scale": true
			},
			"parent_id": "08519255-b76e-4ce9-b448-c21f5d94d4a6",
			"parent_table": "block",
			"file_ids": [
				"872bdca1-017c-4611-ab60-376b24452c0d"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/8c967454-2b72-4c95-ad7f-3691c1b90294.png"
		},
		{
			"id": "1a720ced-0bbb-4165-9a52-ba8b5ce30f41",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Ничего не мешает указать название сервиса"
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "770de04d-3f1b-4f6c-8daa-08a18912b711",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "08519255-b76e-4ce9-b448-c21f5d94d4a6",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "921c2b52-86cb-45f7-a23f-ee345d33203a",
			"type": "image",
			"properties": {
				"size": [
					[
						"112.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/811e9dd3-9f1b-49e3-8101-13a651a2638d/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/811e9dd3-9f1b-49e3-8101-13a651a2638d/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.27906976744186046,
				"block_preserve_scale": true
			},
			"parent_id": "6371b570-cba2-4780-93fa-6f18bccd53dd",
			"parent_table": "block",
			"file_ids": [
				"811e9dd3-9f1b-49e3-8101-13a651a2638d"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/921c2b52-86cb-45f7-a23f-ee345d33203a.png"
		},
		{
			"id": "ae84e551-db85-4a90-a8e8-3d2f55ac5fb2",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Не указано название сервиса, человек мог отвлечься и забыть"
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "18edc1d9-ffd5-449b-81dc-c3348ca100c2",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "6371b570-cba2-4780-93fa-6f18bccd53dd",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "791cb351-1242-41aa-bf68-fd2a2954eb1a",
			"type": "column",
			"content": [
				"703f2d0a-fa17-46f3-8353-570dfc474eee",
				"8a7cad41-78ee-46be-bd0b-1b177abb902a"
			],
			"format": {
				"column_ratio": 0.49999999999999994,
				"copied_from_pointer": {
					"id": "1dd1615b-b414-48b1-8f5f-915bc15732ec",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d397907c-6653-4dcb-95d9-f49288bb4286",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "93c5bd63-b4ae-41ee-8bd2-1aced659f8c9",
			"type": "column",
			"content": [
				"a2bb3b58-a680-4a53-869a-36f2da35a651",
				"8def6c88-461f-4c2f-8065-1d079fcfc5b3"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "52279374-a32d-43f9-9e6e-c85dbf8b3300",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "d397907c-6653-4dcb-95d9-f49288bb4286",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "703f2d0a-fa17-46f3-8353-570dfc474eee",
			"type": "image",
			"properties": {
				"size": [
					[
						"166.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/b90e72cd-34fe-4a26-b0ec-d92918f28342/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/b90e72cd-34fe-4a26-b0ec-d92918f28342/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 1.6337209302325582,
				"block_preserve_scale": true
			},
			"parent_id": "791cb351-1242-41aa-bf68-fd2a2954eb1a",
			"parent_table": "block",
			"file_ids": [
				"b90e72cd-34fe-4a26-b0ec-d92918f28342"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/703f2d0a-fa17-46f3-8353-570dfc474eee.png"
		},
		{
			"id": "8a7cad41-78ee-46be-bd0b-1b177abb902a",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Спокойно объяснили и дали все возможности, чтобы решить задачу"
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "6d4da8c7-c691-443a-8022-afd3d7355e03",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "791cb351-1242-41aa-bf68-fd2a2954eb1a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "a2bb3b58-a680-4a53-869a-36f2da35a651",
			"type": "image",
			"properties": {
				"size": [
					[
						"143.4KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/f09f72e0-dbd4-4a3c-8ab3-8212ca05cfc2/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/f09f72e0-dbd4-4a3c-8ab3-8212ca05cfc2/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 1.6337209302325582,
				"block_preserve_scale": true
			},
			"parent_id": "93c5bd63-b4ae-41ee-8bd2-1aced659f8c9",
			"parent_table": "block",
			"file_ids": [
				"f09f72e0-dbd4-4a3c-8ab3-8212ca05cfc2"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/a2bb3b58-a680-4a53-869a-36f2da35a651.png"
		},
		{
			"id": "8def6c88-461f-4c2f-8065-1d079fcfc5b3",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Непоследовательны мы — непоследовательно ведём человека \n\nЗвучим угрожающе — что-то запрещено"
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "b93b126a-e5cf-4f4b-aba3-ef86fee2184e",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "93c5bd63-b4ae-41ee-8bd2-1aced659f8c9",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "41024785-c813-4fe6-9ca3-6bbe3e99ea84",
			"type": "column",
			"content": [
				"fa1f5916-2dd2-4bc7-a949-711411a8b35c",
				"296c0439-7bd0-4d86-a79f-6552c53762bd"
			],
			"format": {
				"column_ratio": 0.49999999999999994,
				"copied_from_pointer": {
					"id": "76a4e886-7a2f-40e9-8984-52d1dfc24a1c",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "69dbba0f-7216-4d58-9626-894d7577bc38",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "fdf5ee8e-1648-4353-b45d-7764cd558c63",
			"type": "column",
			"content": [
				"40001798-72ac-4d96-b3d8-9592bd8290f3",
				"1fa9c6a3-7e5f-411b-90be-0f887bcf5178"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "7dd4603d-9ff3-460e-9309-22729858cd6b",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "69dbba0f-7216-4d58-9626-894d7577bc38",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "fa1f5916-2dd2-4bc7-a949-711411a8b35c",
			"type": "image",
			"properties": {
				"size": [
					[
						"31.7KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/a40796de-8c4a-411c-84d4-aae3f9d6ab58/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/a40796de-8c4a-411c-84d4-aae3f9d6ab58/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.26453488372093026,
				"block_preserve_scale": true
			},
			"parent_id": "41024785-c813-4fe6-9ca3-6bbe3e99ea84",
			"parent_table": "block",
			"file_ids": [
				"a40796de-8c4a-411c-84d4-aae3f9d6ab58"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/fa1f5916-2dd2-4bc7-a949-711411a8b35c.png"
		},
		{
			"id": "296c0439-7bd0-4d86-a79f-6552c53762bd",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Оповестили без лишних уточнений и дали возможность узнать подробнее в Справке"
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "c18a9e1d-0a47-4e4f-b5ae-9fc5c2d91ac1",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "41024785-c813-4fe6-9ca3-6bbe3e99ea84",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "40001798-72ac-4d96-b3d8-9592bd8290f3",
			"type": "image",
			"properties": {
				"size": [
					[
						"42.2KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/ff88f6b8-a449-49c0-92c2-ef16ecda8526/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/ff88f6b8-a449-49c0-92c2-ef16ecda8526/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.26453488372093026,
				"block_preserve_scale": true
			},
			"parent_id": "fdf5ee8e-1648-4353-b45d-7764cd558c63",
			"parent_table": "block",
			"file_ids": [
				"ff88f6b8-a449-49c0-92c2-ef16ecda8526"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/40001798-72ac-4d96-b3d8-9592bd8290f3.png"
		},
		{
			"id": "1fa9c6a3-7e5f-411b-90be-0f887bcf5178",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Мы здесь буквально говорим — «скачай заражённый файл»\n\nПовторение слов, нет буквы «ё»"
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "0140ba1d-ca84-4765-b3d4-f67b6933faa1",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "fdf5ee8e-1648-4353-b45d-7764cd558c63",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "ba10075f-1e7e-427d-99b7-0fca0feab4da",
			"type": "column",
			"content": [
				"c3f6d757-7d68-4973-a180-dd407ee2cc9e",
				"4a3cfbaf-289e-4766-b5a3-1fc0700dd779"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "00917d81-709c-4b6b-88f1-9d0008113c7d",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "0d30ccd0-c955-42f2-b070-e09fce91aff3",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "68cae18c-3a9d-4db6-99eb-4a690b91643b",
			"type": "column",
			"content": [
				"3f546f9e-51c6-43f7-92fc-85c653913ff3",
				"1daa0225-828d-45aa-9963-7669020b3757"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "d6eda542-c795-4783-b8d6-e8036a79a6c7",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "0d30ccd0-c955-42f2-b070-e09fce91aff3",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "c3f6d757-7d68-4973-a180-dd407ee2cc9e",
			"type": "image",
			"properties": {
				"size": [
					[
						"80.7KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/db72f174-3609-44c5-b3b1-2a241f3cd04c/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/db72f174-3609-44c5-b3b1-2a241f3cd04c/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.7005813953488372,
				"block_preserve_scale": true
			},
			"parent_id": "ba10075f-1e7e-427d-99b7-0fca0feab4da",
			"parent_table": "block",
			"file_ids": [
				"db72f174-3609-44c5-b3b1-2a241f3cd04c"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/c3f6d757-7d68-4973-a180-dd407ee2cc9e.png"
		},
		{
			"id": "4a3cfbaf-289e-4766-b5a3-1fc0700dd779",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Ушли от одушевления — смысл, при этом, не потерялся \n\nСнизили градус и не кричим "
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "a9f60c14-8946-4ae4-b1be-1a2ce488386b",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "ba10075f-1e7e-427d-99b7-0fca0feab4da",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "3f546f9e-51c6-43f7-92fc-85c653913ff3",
			"type": "image",
			"properties": {
				"size": [
					[
						"83.1KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/268cc6cc-2fbd-4739-885c-50f87e628eed/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/268cc6cc-2fbd-4739-885c-50f87e628eed/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.7005813953488372,
				"block_preserve_scale": true
			},
			"parent_id": "68cae18c-3a9d-4db6-99eb-4a690b91643b",
			"parent_table": "block",
			"file_ids": [
				"268cc6cc-2fbd-4739-885c-50f87e628eed"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/3f546f9e-51c6-43f7-92fc-85c653913ff3.png"
		},
		{
			"id": "1daa0225-828d-45aa-9963-7669020b3757",
			"type": "callout",
			"properties": {
				"title": [
					[
						"«Мы» одушевляет интерфейс \nи задаёт излишние ожидания \n\nНеуместный восторг"
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "39277102-1461-401d-916d-299223d3bc34",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "68cae18c-3a9d-4db6-99eb-4a690b91643b",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "a611fb48-0219-4f35-91e4-e51ac884faa0",
			"type": "column",
			"content": [
				"842edde8-898d-492d-a6bb-decbd5cfe870",
				"a11bb974-a7a3-41c3-8849-25ae0602f567"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "b6db0518-20b7-487a-94de-812d43122395",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "77508c0d-e445-45d6-88bf-87270dd032c9",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "b5597867-a03e-413b-9038-ce903d910f8b",
			"type": "column",
			"content": [
				"9a2fd137-df51-4440-a120-c73e43d73a53",
				"0d414895-58a2-4fb4-bc84-e110e11e2e84"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "e5de52c0-c40f-4359-835d-18deff4a4797",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "77508c0d-e445-45d6-88bf-87270dd032c9",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "842edde8-898d-492d-a6bb-decbd5cfe870",
			"type": "image",
			"properties": {
				"size": [
					[
						"332.2KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/58b60518-a2c9-486c-8c08-85cf9e8d0836/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/58b60518-a2c9-486c-8c08-85cf9e8d0836/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 1.002906976744186,
				"block_preserve_scale": true
			},
			"parent_id": "a611fb48-0219-4f35-91e4-e51ac884faa0",
			"parent_table": "block",
			"file_ids": [
				"58b60518-a2c9-486c-8c08-85cf9e8d0836"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/842edde8-898d-492d-a6bb-decbd5cfe870.png"
		},
		{
			"id": "a11bb974-a7a3-41c3-8849-25ae0602f567",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Сохранили принцип: главное для человека — вперёд \n\nУбрали лишнее — теперь речь про одну сущность, Облако \n\nНавели порядок — убрали лишнее, почистили висящие штуки "
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "21eeb528-8c98-48a6-bead-c31b76aade5d",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "a611fb48-0219-4f35-91e4-e51ac884faa0",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "9a2fd137-df51-4440-a120-c73e43d73a53",
			"type": "image",
			"properties": {
				"size": [
					[
						"332.0KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/40c3da15-f9e1-40b8-9d22-c4ee312f1541/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/40c3da15-f9e1-40b8-9d22-c4ee312f1541/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 1.002906976744186,
				"block_preserve_scale": true
			},
			"parent_id": "b5597867-a03e-413b-9038-ce903d910f8b",
			"parent_table": "block",
			"file_ids": [
				"40c3da15-f9e1-40b8-9d22-c4ee312f1541"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/9a2fd137-df51-4440-a120-c73e43d73a53.png"
		},
		{
			"id": "0d414895-58a2-4fb4-bc84-e110e11e2e84",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Хранилище и Облако — в нашем мире одно и то же, но в мире человека — разное\n\nКнопки — по смыслу одинаковые \n\nШумно — висят частицы"
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "f5999e9d-4cb9-4e1b-b508-8ae5c16d1d6a",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "b5597867-a03e-413b-9038-ce903d910f8b",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "3f411231-1c05-4044-b6c8-e8f07fe31dba",
			"type": "column",
			"content": [
				"ceae6ef2-3729-4bc8-a52b-39158a82968b",
				"16f9ae75-6757-4003-9562-a6156e1886b2"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "501ce3c2-cc90-4151-8b62-d0181a1cde82",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "83133309-2c76-4e2c-8bcf-327be7a76708",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "16125059-7f7b-4ffd-8b6d-05c04f7861a6",
			"type": "column",
			"content": [
				"26fa6f2d-76a3-4fb4-8904-4ca94f2d7165",
				"15d1bec4-19ba-4f26-b603-6bba411e985d"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "320ac529-2c78-401b-a0fd-f05af933e068",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "83133309-2c76-4e2c-8bcf-327be7a76708",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "ceae6ef2-3729-4bc8-a52b-39158a82968b",
			"type": "image",
			"properties": {
				"size": [
					[
						"210.7KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/0fdd633c-4d3b-4779-b9e0-dfc4c3e980ba/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/0fdd633c-4d3b-4779-b9e0-dfc4c3e980ba/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.7005813953488372,
				"block_preserve_scale": true
			},
			"parent_id": "3f411231-1c05-4044-b6c8-e8f07fe31dba",
			"parent_table": "block",
			"file_ids": [
				"0fdd633c-4d3b-4779-b9e0-dfc4c3e980ba"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/ceae6ef2-3729-4bc8-a52b-39158a82968b.png"
		},
		{
			"id": "16f9ae75-6757-4003-9562-a6156e1886b2",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Заголовок отражает суть \n\nУправляем вниманием с помощью коротких структурированных сообщений \n\nДаём конкретику — название системы"
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "b3296492-fc66-4fe4-92f1-f0914a03034b",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "3f411231-1c05-4044-b6c8-e8f07fe31dba",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "26fa6f2d-76a3-4fb4-8904-4ca94f2d7165",
			"type": "image",
			"properties": {
				"size": [
					[
						"221.9KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/1434b350-c33c-4b16-8b80-40f5d77e754e/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/1434b350-c33c-4b16-8b80-40f5d77e754e/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.7005813953488372,
				"block_preserve_scale": true
			},
			"parent_id": "16125059-7f7b-4ffd-8b6d-05c04f7861a6",
			"parent_table": "block",
			"file_ids": [
				"1434b350-c33c-4b16-8b80-40f5d77e754e"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/26fa6f2d-76a3-4fb4-8904-4ca94f2d7165.png"
		},
		{
			"id": "15d1bec4-19ba-4f26-b603-6bba411e985d",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Очень длинный текст \n\nКлише: «всего за три секунды», «просто войдите»\n\nБездоказательное усиление: \n«в надёжном месте»\n\nНеуникальный заголовок \n\nВисит предлог "
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "b49e7134-837c-4ef6-b902-3b831adbb4bc",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "16125059-7f7b-4ffd-8b6d-05c04f7861a6",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "8c07149c-d46c-4fdf-85ad-ea9ba47ca960",
			"type": "column",
			"content": [
				"01f107eb-12b7-4efa-898d-6c482e086b80",
				"5a7e3006-9e25-4a52-9bcb-488d4a43fcfc"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "fd6e4704-4aae-44b1-96af-9c9d6e51aea7",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "1dfa947b-8c0a-486b-9983-01d376068efa",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "7f255c25-629b-482b-ae7c-9656d63a0ead",
			"type": "column",
			"content": [
				"daa913f8-c028-49bd-98c5-4ac7bbfb9e29",
				"e5a49cb5-ffa7-45f4-81e5-1a0c6626528e"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "675b4a5f-5262-41bf-b9d4-e48cbd2c269d",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "1dfa947b-8c0a-486b-9983-01d376068efa",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "01f107eb-12b7-4efa-898d-6c482e086b80",
			"type": "image",
			"properties": {
				"size": [
					[
						"84.6KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/a760d889-fa8d-4590-b72b-fdbc9ed69e2a/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/a760d889-fa8d-4590-b72b-fdbc9ed69e2a/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.7267441860465116,
				"block_preserve_scale": true
			},
			"parent_id": "8c07149c-d46c-4fdf-85ad-ea9ba47ca960",
			"parent_table": "block",
			"file_ids": [
				"a760d889-fa8d-4590-b72b-fdbc9ed69e2a"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/01f107eb-12b7-4efa-898d-6c482e086b80.png"
		},
		{
			"id": "5a7e3006-9e25-4a52-9bcb-488d4a43fcfc",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Дали подсказку в инпуте \n\nВизуально навели порядок \n\nКнопки раздельны по смыслу "
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "8080dbb3-65f5-4a0a-9fee-67cb577cac07",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "8c07149c-d46c-4fdf-85ad-ea9ba47ca960",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "daa913f8-c028-49bd-98c5-4ac7bbfb9e29",
			"type": "image",
			"properties": {
				"size": [
					[
						"87.1KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/37fe655c-31ad-43c4-a017-81b4c3b1ff51/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/37fe655c-31ad-43c4-a017-81b4c3b1ff51/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.7267441860465116,
				"block_preserve_scale": true
			},
			"parent_id": "7f255c25-629b-482b-ae7c-9656d63a0ead",
			"parent_table": "block",
			"file_ids": [
				"37fe655c-31ad-43c4-a017-81b4c3b1ff51"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/daa913f8-c028-49bd-98c5-4ac7bbfb9e29.png"
		},
		{
			"id": "e5a49cb5-ffa7-45f4-81e5-1a0c6626528e",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Подсказка в инпуте не перегрузит, но подскажет \n\nПохожие кнопки — путают \n\nВизуальный шум — висит предлог"
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "dc051bc0-75e5-4ceb-8cd6-48d20a9ebad1",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "7f255c25-629b-482b-ae7c-9656d63a0ead",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "29408658-f118-4d45-b985-df506284e5c2",
			"type": "column",
			"content": [
				"6adb9999-8361-42cc-a98b-21c054fafe94",
				"6d3bb6d1-5111-453f-89bc-2a9c658b1acd"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "be84e9ed-bb60-4840-9033-ba08437e8b8d",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "7a5e35b1-f541-4d20-b840-928e56932443",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "6660c04b-9b0f-4da7-ae62-7255ca52ee1f",
			"type": "column",
			"content": [
				"be007f52-26fd-419b-850a-3753de9dd3cd",
				"2263dbba-6329-4d37-8a0d-7f39bfcc1fb0"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "f76cf9bf-e660-4658-9113-553ec0f95ab3",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "7a5e35b1-f541-4d20-b840-928e56932443",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "6adb9999-8361-42cc-a98b-21c054fafe94",
			"type": "image",
			"properties": {
				"size": [
					[
						"167.1KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/3f5dfa01-2a8e-443a-a176-0e1f49237525/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/3f5dfa01-2a8e-443a-a176-0e1f49237525/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.7122093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "29408658-f118-4d45-b985-df506284e5c2",
			"parent_table": "block",
			"file_ids": [
				"3f5dfa01-2a8e-443a-a176-0e1f49237525"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/6adb9999-8361-42cc-a98b-21c054fafe94.png"
		},
		{
			"id": "6d3bb6d1-5111-453f-89bc-2a9c658b1acd",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Оставили суть \n\nНавели визуальный порядок \n\nКнопки однозначны — если сложить с заголовком, получится цельная конструкция. \nПонятная, без пояснений "
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "74a809ef-27c3-41bb-b1d1-6063cf64be01",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "29408658-f118-4d45-b985-df506284e5c2",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "be007f52-26fd-419b-850a-3753de9dd3cd",
			"type": "image",
			"properties": {
				"size": [
					[
						"193.4KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/ae6158e6-b927-41ff-8d5e-39f70af5a0d2/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/ae6158e6-b927-41ff-8d5e-39f70af5a0d2/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.7122093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "6660c04b-9b0f-4da7-ae62-7255ca52ee1f",
			"parent_table": "block",
			"file_ids": [
				"ae6158e6-b927-41ff-8d5e-39f70af5a0d2"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/be007f52-26fd-419b-850a-3753de9dd3cd.png"
		},
		{
			"id": "2263dbba-6329-4d37-8a0d-7f39bfcc1fb0",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Главное — не на первом месте\n\nШумно — висит предлог "
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "81d0da67-66ab-4a2d-904a-ffd0e2dd954b",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "6660c04b-9b0f-4da7-ae62-7255ca52ee1f",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "986672ce-7d08-4d04-ad08-ba5f1755fbfb",
			"type": "column",
			"content": [
				"2ec8d2d1-df13-4488-966d-4ce95dfe5699",
				"e7b04555-b46b-4783-8796-1cb801d17a5a"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "1121e4fa-eb77-415e-94c4-2d6e02bc1593",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "0ccf3666-e856-46b2-a49b-5645a1a03a4e",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "8a40e9cd-38b2-45a6-ae81-7bc12f4a4e0d",
			"type": "column",
			"content": [
				"aada6371-18dc-4828-951f-579d03aa4585",
				"0f067660-e362-4084-974f-da7615804bde"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "508217d3-598d-4d08-bcf6-9306967e7d00",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "0ccf3666-e856-46b2-a49b-5645a1a03a4e",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "2ec8d2d1-df13-4488-966d-4ce95dfe5699",
			"type": "image",
			"properties": {
				"size": [
					[
						"220.0KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/e58222f7-9f9f-47e4-9b70-f3824cd719c2/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/e58222f7-9f9f-47e4-9b70-f3824cd719c2/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.6191860465116279,
				"block_preserve_scale": true
			},
			"parent_id": "986672ce-7d08-4d04-ad08-ba5f1755fbfb",
			"parent_table": "block",
			"file_ids": [
				"e58222f7-9f9f-47e4-9b70-f3824cd719c2"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/2ec8d2d1-df13-4488-966d-4ce95dfe5699.png"
		},
		{
			"id": "e7b04555-b46b-4783-8796-1cb801d17a5a",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Даём надежду уже в заголовке, \nа не начинаем с «не»\n\nНавели визуальный порядок \n\nКнопка +заголовок = единая конструкция, которая даёт понимание, что происходит "
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "330e9c85-40f8-4d62-84e4-bbdb579a86c5",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "986672ce-7d08-4d04-ad08-ba5f1755fbfb",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "aada6371-18dc-4828-951f-579d03aa4585",
			"type": "image",
			"properties": {
				"size": [
					[
						"222.1KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/d092c511-1d3c-47ac-8e96-99e390e96878/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/d092c511-1d3c-47ac-8e96-99e390e96878/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.622093023255814,
				"block_preserve_scale": true
			},
			"parent_id": "8a40e9cd-38b2-45a6-ae81-7bc12f4a4e0d",
			"parent_table": "block",
			"file_ids": [
				"d092c511-1d3c-47ac-8e96-99e390e96878"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/aada6371-18dc-4828-951f-579d03aa4585.png"
		},
		{
			"id": "0f067660-e362-4084-974f-da7615804bde",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Нет связи между заголовком и текстом под ним \n\nПравило: заголовок + кнопки = сязный текст — не выполнено \n\nНепонятно, к кому обращается модалка"
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "da1d8945-0e63-4c61-aa7a-82d78ee22d11",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "8a40e9cd-38b2-45a6-ae81-7bc12f4a4e0d",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "7515f335-4867-4de2-ad50-35f68711fa07",
			"type": "column",
			"content": [
				"73ad23b2-4b03-42d6-adfa-fbe0d3aa13e3",
				"d3a8b5f3-b41a-408f-8810-b8badde2a299"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "7d5bf692-aecb-4d6e-b496-4a64e6217ef3",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "8488bb87-a262-44c5-a36d-9ae7b6ffc512",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "7bf106db-cd26-4155-9fd3-ee3426b8a2fb",
			"type": "column",
			"content": [
				"5f62798e-714a-4303-a374-34a3a967dfd6",
				"51d9397c-316d-440b-80a6-f0855efbae5f"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "5488fa07-27f6-435a-9223-fcd91ec2d115",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "8488bb87-a262-44c5-a36d-9ae7b6ffc512",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "73ad23b2-4b03-42d6-adfa-fbe0d3aa13e3",
			"type": "image",
			"properties": {
				"size": [
					[
						"45.7KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/a99a7ba1-5308-49c0-9f26-80a5f715d13a/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/a99a7ba1-5308-49c0-9f26-80a5f715d13a/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.4680232558139535,
				"block_preserve_scale": true
			},
			"parent_id": "7515f335-4867-4de2-ad50-35f68711fa07",
			"parent_table": "block",
			"file_ids": [
				"a99a7ba1-5308-49c0-9f26-80a5f715d13a"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/73ad23b2-4b03-42d6-adfa-fbe0d3aa13e3.png"
		},
		{
			"id": "d3a8b5f3-b41a-408f-8810-b8badde2a299",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Всё на своих местах — говорим про корзину, и чистим её же "
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "0b0d3087-c93b-481e-a93c-17fb49cb97a4",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "7515f335-4867-4de2-ad50-35f68711fa07",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "5f62798e-714a-4303-a374-34a3a967dfd6",
			"type": "image",
			"properties": {
				"size": [
					[
						"44.1KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/58145a2d-4f05-480a-a224-c46372985c9c/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/58145a2d-4f05-480a-a224-c46372985c9c/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.4680232558139535,
				"block_preserve_scale": true
			},
			"parent_id": "7bf106db-cd26-4155-9fd3-ee3426b8a2fb",
			"parent_table": "block",
			"file_ids": [
				"58145a2d-4f05-480a-a224-c46372985c9c"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/5f62798e-714a-4303-a374-34a3a967dfd6.png"
		},
		{
			"id": "51d9397c-316d-440b-80a6-f0855efbae5f",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Непонятно, что в итоге я чищу — папку или корзину"
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "c2b4ef78-be19-49dc-97a1-06f3f5807d2e",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "7bf106db-cd26-4155-9fd3-ee3426b8a2fb",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "7d5fbfd5-72de-4655-828b-47939335c012",
			"type": "column",
			"content": [
				"ba07cc41-c4db-4ea0-a95a-b429fcba9abe",
				"a4dc208e-b91b-4724-8633-b460c464acb4"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "da899d6b-309e-44ef-92a4-c836caafbe0a",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "b3988dd0-2f22-4e26-b7d9-bf930a6ddc12",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "a04d2ec9-bd8d-480c-8375-6b6f4196e7d3",
			"type": "column",
			"content": [
				"854f9975-8281-4718-9757-fa0171bafc01",
				"b91919e1-e88c-40c5-ad9d-1f3e733f3316"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "e307b0ea-ce44-4d68-972c-e53c65bd3ff4",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "b3988dd0-2f22-4e26-b7d9-bf930a6ddc12",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "ba07cc41-c4db-4ea0-a95a-b429fcba9abe",
			"type": "image",
			"properties": {
				"size": [
					[
						"58.9KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/f3aeada4-1bdf-4b50-bc45-7c8bcde6b18e/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/f3aeada4-1bdf-4b50-bc45-7c8bcde6b18e/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.5058139534883721,
				"block_preserve_scale": true
			},
			"parent_id": "7d5fbfd5-72de-4655-828b-47939335c012",
			"parent_table": "block",
			"file_ids": [
				"f3aeada4-1bdf-4b50-bc45-7c8bcde6b18e"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/ba07cc41-c4db-4ea0-a95a-b429fcba9abe.png"
		},
		{
			"id": "a4dc208e-b91b-4724-8633-b460c464acb4",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Главное вынесли вперёд — там, где можно обойтись сутью в заголовке — делаем это \n\nЗаголовок + кнопка = понятная \nи складная фраза "
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "7df6754e-8425-436d-9051-ac450316da34",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "7d5fbfd5-72de-4655-828b-47939335c012",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "854f9975-8281-4718-9757-fa0171bafc01",
			"type": "image",
			"properties": {
				"size": [
					[
						"64.9KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/871198fa-5ef2-48c0-9b3a-ebd8d7dc3b4b/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/871198fa-5ef2-48c0-9b3a-ebd8d7dc3b4b/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.5058139534883721,
				"block_preserve_scale": true
			},
			"parent_id": "a04d2ec9-bd8d-480c-8375-6b6f4196e7d3",
			"parent_table": "block",
			"file_ids": [
				"871198fa-5ef2-48c0-9b3a-ebd8d7dc3b4b"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/854f9975-8281-4718-9757-fa0171bafc01.png"
		},
		{
			"id": "b91919e1-e88c-40c5-ad9d-1f3e733f3316",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Заголовок + кнопка — не равно цельная и понятная конструкция \n\n«Отменить удаление»: глагол + глагольное — усложнили там, где просто \n\n4 раза «удаление»\n"
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "299cb0b8-4317-4ef1-81be-15e2c412c6dc",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "a04d2ec9-bd8d-480c-8375-6b6f4196e7d3",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "b52d904f-85f0-4110-86dc-b6fcc4e236a8",
			"type": "column",
			"content": [
				"008d0c3b-b84c-44f9-be08-530e3b66a2a4",
				"611476bf-bc40-4fd5-966b-647b79c67d21"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "34780a9c-675b-4fa4-b645-12bea0372b54",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "1d78aa8d-a943-4727-888a-9ba777486fbb",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "484161ae-20f0-481a-b069-0f83de7738b5",
			"type": "column",
			"content": [
				"35d91616-d71c-4272-980e-ed5ccdd879aa",
				"a252126e-c496-4401-aea4-935a639400c8"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "e083aa59-1ac7-48d8-9ad7-e36e9586c565",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "1d78aa8d-a943-4727-888a-9ba777486fbb",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "008d0c3b-b84c-44f9-be08-530e3b66a2a4",
			"type": "image",
			"properties": {
				"size": [
					[
						"100.1KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/c6bedbbe-f991-42bb-a34f-e28d9bf2167a/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/c6bedbbe-f991-42bb-a34f-e28d9bf2167a/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.7906976744186046,
				"block_preserve_scale": true
			},
			"parent_id": "b52d904f-85f0-4110-86dc-b6fcc4e236a8",
			"parent_table": "block",
			"file_ids": [
				"c6bedbbe-f991-42bb-a34f-e28d9bf2167a"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/008d0c3b-b84c-44f9-be08-530e3b66a2a4.png"
		},
		{
			"id": "611476bf-bc40-4fd5-966b-647b79c67d21",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Начали сразу с сути и главного для человека \n\nУбрали кнопки, которые дублируют друг друга по смыслу "
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "d93a3e33-2b74-4de7-a851-55bd349e2659",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "b52d904f-85f0-4110-86dc-b6fcc4e236a8",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "35d91616-d71c-4272-980e-ed5ccdd879aa",
			"type": "image",
			"properties": {
				"size": [
					[
						"121.8KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/2da300e0-8d06-4a3a-9616-c5269404f363/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/2da300e0-8d06-4a3a-9616-c5269404f363/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.7906976744186046,
				"block_preserve_scale": true
			},
			"parent_id": "484161ae-20f0-481a-b069-0f83de7738b5",
			"parent_table": "block",
			"file_ids": [
				"2da300e0-8d06-4a3a-9616-c5269404f363"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/35d91616-d71c-4272-980e-ed5ccdd879aa.png"
		},
		{
			"id": "a252126e-c496-4401-aea4-935a639400c8",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Кнопки «Не сохранять» и «Отменить» для человека одно и то же"
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "22d9d680-5956-45d2-9f99-68e283e69cb7",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "484161ae-20f0-481a-b069-0f83de7738b5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "b906eafc-7595-4f40-a47b-cef03dc1bbf0",
			"type": "column",
			"content": [
				"f481f87c-ef6c-4026-9639-80dbfcb7de3d",
				"715d66d3-06c5-4e04-82ef-3e9de0f16570"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "1bc7a970-21ff-427c-a42d-ff0128b3e4b5",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "62d7c108-dc3a-4249-8962-4feecfcce0b6",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "42e7fd64-f04b-4be9-928a-1152e38230fa",
			"type": "column",
			"content": [
				"97cecaa4-4bee-406d-be61-d70761aab8a8",
				"17b6906a-57fd-431e-a12e-30f6514e743f"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "636ba495-1578-445d-9b23-d7f8f7747a28",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "62d7c108-dc3a-4249-8962-4feecfcce0b6",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "f481f87c-ef6c-4026-9639-80dbfcb7de3d",
			"type": "image",
			"properties": {
				"size": [
					[
						"42.1KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/37a0f9d0-2304-49b8-b732-1b265142b581/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/37a0f9d0-2304-49b8-b732-1b265142b581/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.6831395348837209,
				"block_preserve_scale": true
			},
			"parent_id": "b906eafc-7595-4f40-a47b-cef03dc1bbf0",
			"parent_table": "block",
			"file_ids": [
				"37a0f9d0-2304-49b8-b732-1b265142b581"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/f481f87c-ef6c-4026-9639-80dbfcb7de3d.png"
		},
		{
			"id": "715d66d3-06c5-4e04-82ef-3e9de0f16570",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Список консистентный — читать и воспринимать легко\n\nПоследовательно "
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "f1320939-3b1a-40cd-81d5-629edb97ac46",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "b906eafc-7595-4f40-a47b-cef03dc1bbf0",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "97cecaa4-4bee-406d-be61-d70761aab8a8",
			"type": "image",
			"properties": {
				"size": [
					[
						"40.4KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/a36db1d9-788d-432d-b467-84177a814df3/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/a36db1d9-788d-432d-b467-84177a814df3/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.6831395348837209,
				"block_preserve_scale": true
			},
			"parent_id": "42e7fd64-f04b-4be9-928a-1152e38230fa",
			"parent_table": "block",
			"file_ids": [
				"a36db1d9-788d-432d-b467-84177a814df3"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/97cecaa4-4bee-406d-be61-d70761aab8a8.png"
		},
		{
			"id": "17b6906a-57fd-431e-a12e-30f6514e743f",
			"type": "callout",
			"properties": {
				"title": [
					[
						"«Настройка вида» — не согласуется со следующими глагольными формами списка\n\nНет конкретики — настройка чего?\n\nНепоследовательно "
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "d7c7d553-e6a6-4882-a43a-7420238e1e1c",
					"table": "block",
					"spaceId": "14aa773c-e459-4830-a072-aaa829289e58"
				}
			},
			"parent_id": "42e7fd64-f04b-4be9-928a-1152e38230fa",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		}
	],
	"headers": [
		{
			"title": "Главное для человека — вперёд",
			"id": "7a5b6773-65f7-497b-8888-787d4f4a4703"
		},
		{
			"title": "Польза и помощь",
			"id": "b033793a-e999-497a-8ce9-0bd2b15e0837"
		},
		{
			"title": "Лаконично, точно, консистентно ",
			"id": "4aa6a65b-1de4-48c4-8491-7d46ee8f7cc7"
		}
	]
}} />
);

export default NotionVoiceAndToneInterface;
